class @EmailThread
  constructor: ->
    $('table#emails tr').on 'click', ->
      window.document.location = $(this).data('href')

window.EmailThread = @EmailThread;
